import {OrderListConfig} from "../../components/orders/models/OrderListConfig";
import DefaultOpenOrdersColumns from "./DefaultOpenEquityOrdersColumns";
import {WorkingOrderListOrderBy} from "../../components/orders/models/WorkingOrderListOrderBy";
import DefaultCompletedOrdersColumns from "./DefaultCompletedEquityOrdersColumns";

export default {
    working: {
        columns: DefaultOpenOrdersColumns,
        order: WorkingOrderListOrderBy.ORDER_TREE,
        onlyMine: false
    },
    completed: {
        columns: DefaultCompletedOrdersColumns,
        includeUnfilled: false,
        onlyMine: false
    }
} as OrderListConfig;
